<template>
  <div class="package">
    <div class="flex justify-between items-center pb-6 shadow-border-b gap-8 mdmax:gap-2 mdmax:flex-col">
      <div class="flex-1 mdmax:flex-auto mdmax:w-full">
        <LinkButton buttonText="Tambah Layanan" url="/package/create" linkType="internal" :size="isMobile ? 'full' : 'regular'" />
      </div>
      <div class="flex-1 flex justify-end gap-8 mdmax:flex-auto mdmax:w-full mdmax:justify-start">
        <div class="w-3/5  mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Pencarian</label>
          <div class="relative">
            <TextField type="text" :withIcon="true" placeholder="Cari nama kategori barang" v-model="searchTerm" @enter="doSearch" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
          </div>
        </div>
      </div>
    </div>
    <TableComponent :columns="columns" :list="filteredData">
      <template slot="table-row" slot-scope="{ entry, column }">
        <LinkButton v-if="column.field === 'action'" buttonText="Lihat rincian" :url="`/package/detail/${entry.id}`" linkType="internal" type="secondary" size="small" />
        <span class="block break-all " v-else-if="column.field === 'id'" :title="entry.id">
          {{ entry.id }}
        </span>
        <span class="block" v-else-if="column.field === 'description'">
          <p v-html="entry.description" class=""></p>
        </span>
        <span class="block" v-else-if="column.field === 'delivery_service_type'">
          {{ getDeliveryType(entry.delivery_service_type) }}
        </span>
        <span class="block" v-else-if="column.field === 'tnc'">
          <p v-html="entry.tnc" class=""></p>
        </span>
        <span v-else>{{ entry[column.field] || '-' }}</span>
      </template>
    </TableComponent>
    <div class="mt-8 flex justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
      <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { truncate, capitalize } from '@/util'
export default {
  filters: {
    truncate,
    capitalize
  },
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton'),
    Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination')
  },
  data: () => ({
    searchTerm: '',
    totalRecords: 0,
    currentPage: 1,
    pageSize: 10,
    hasMorePages: true,
    deliveryServiceTypeList: [
      {
        name: 'Pickup and Dropoff',
        value: 'A'
      },
      {
        name: 'Pickup Only',
        value: 'P'
      },
      {
        name: 'Dropoff Only',
        value: 'D'
      }
    ],
    columns: [
      // { label: 'ID', field: 'id' },
      { label: 'Nama Layanan', field: 'name' },
      { label: 'Deskripsi', field: 'description' },
      { label: 'Tipe Layanan', field: 'delivery_service_type' },
      // { label: 'Kategori Barang', field: 'goodsCategory' },
      { label: 'Syarat & Ketentuan', field: 'tnc' },
      { label: 'Status', field: 'status' },
      { label: 'Action', field: 'action' }
    ]
  }),
  computed: {
    ...mapGetters('partner', ['packageList']),
    ...mapGetters('auth', ['userData']),
    ...mapGetters('common', ['isMobile']),
    filteredData() {
      let temp = this.packageList || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.perPage + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.perPage + this.perPage
      return lastOnPage > this.total ? this.total : lastOnPage
    }
  },
  methods: {
    ...mapActions('partner', ['getPackageList']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    getPackage(searchTerm = '') {
      this.showLoading()
      const partnerId = this.userData?.user?.group_id
      this.getPackageList({
        id: partnerId,
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: searchTerm,
          sort: 'DESC'
        }
      })
        .then(res => {
          this.totalRecords = res.data.meta.total_item
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    onPageChange(page) {
      this.currentPage = page
      this.$router.push({ path: '/package', query: { page: page } })
    },
    doSearch() {
      this.getPackage(this.searchTerm)
    },
    showMore(page) {
      this.$router.push({ path: '/package', query: { page: page } })
      this.page = page
      this.currentPage = page
    },
    goToDetail(target) {
      this.$router.push(`/package/detail/${target}`)
    },
    getDeliveryType(type) {
      return this.deliveryServiceTypeList.filter(item => item.value === type)[0].name
    }
  },
  created() {
    if (!this.$route.query.page) {
      this.$router.push({ path: '/package', query: { page: 1 } })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.getPackage()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.getPackage()
      } else {
        this.$router.push({ path: '/package', query: { page: 1 } })
        this.page = 1
        this.currentPage = 1
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.25;
  height: 40px;
  word-break: break-all;
}
</style>
